import { render, staticRenderFns } from "./ReorderElementPopupComponent.vue?vue&type=template&id=52b9c395"
import script from "./ReorderElementPopupComponent.vue?vue&type=script&lang=js"
export * from "./ReorderElementPopupComponent.vue?vue&type=script&lang=js"
import style0 from "./ReorderElementPopupComponent.vue?vue&type=style&index=0&id=52b9c395&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports